<template>
	<div class="m-list-view flex-grow flex-column">
		<topbar v-if="topbar" ref="topbar" :search="search" :filter="!!$slots.filter" :work-type="customView ? '' : workType" :custom-view="customView" @update="topbarHandle" @empty="state => emptyState = state">
			<template #filter>
				<slot name="filter"></slot>
			</template>
		</topbar>

		<c-empty v-if="emptyState" message="暂无可用视图，请联系管理员处理"></c-empty>

		<template v-else>
			<div v-if="($scopedSlots.batch || approveType) && batchButton && total" class="batch-handle flex-end-center">
				<c-link v-if="batchState" color="red" icon="tf-back" @click="resetBatch(true);">取消操作</c-link>
				<c-link v-else color="main" icon="tf-batch" @click="viewStore.commit('batchState', true)">批量操作</c-link>
			</div>

			<c-scroll-list ref="list" class="flex-grow" :head-height="headHeight" @scroll="batchMenu = false" @refresh="resetBatch(true)">
				<template #head>
					<slot name="head"></slot>
				</template>
	
				<template #default="{data, index}">
					<slot :index="index" :data="data"></slot>
				</template>
			</c-scroll-list>
		</template>

		<div v-if="($scopedSlots.batch || approveType)" class="batch-foot flex-between-center" :class="{'z-active': batchState}">
			<div class="flex-center">
				<c-checkbox v-if="allCheck" :value="allCheckState" @change="allCheckHandle">全选所有</c-checkbox>
				<p>已选：<span>{{allCheckState ? total : checkList.length}}</span>条</p>
			</div>
			<div class="batch-button">
				<c-button color="main" @click.stop="batchHandle">批量操作</c-button>
				<div v-show="batchMenu" ref="batchButton" class="batch-button-list">
					<slot name="batch" :data="allCheckState ? 'all' : checkList" :params="lastLoadParams"></slot>
					<template v-if="approveType">
						<c-button @click="approveHandle(1)">审批通过</c-button>
						<c-button @click="approveHandle(9)">审批驳回</c-button>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {createStore, mapStore} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'viewList',

		props: {
			topbar: {
				type: Boolean,
				default: true
			},
			workType: [String, Number],
			viewId: [String, Number],
			approveType: [String, Number],
			customView: Object,
			search: {
				type: [Boolean, Object],
				default: true
			},
			headHeight: [Number, String],
			immediate: {
				type: Boolean,
				default: true
			},
			allCheck: Boolean
		},

		data() {
			return {
				viewStore: createStore({
					fieldList: [],
					checkList: [],
					batchState: false,
					allCheckState: false,
					checkHandle: (data, state) => {
						if (state) {
							if (!this.checkList.includes(data.id)) {
								this.checkList.push(data.id);
								this.allCheck && this.viewStore.commit('allCheckState', this.checkList.length == this.total)
							}
						} else {
							if (this.checkList.includes(data.id)) {
								this.allCheck && this.viewStore.commit('allCheckState', false);
								this.checkList.splice(this.checkList.findIndex(temp => temp == data.id), 1);
							}
						}
					}
				}),
				lastLoadParams: {},
				coverField: null,
				titleField: null,
				countField: null,
				emptyState: false,
				total: '-',
				batchMenu: false,
				batchButton: true
			}
		},

		computed: {
			...mapStore('viewStore', ['batchState', 'allCheckState', 'checkList']),

			dataUrl() {
				return {
					1: '/aftersale/apply/list',        	// 售后申请单列表
					2: '/after/sale/order/list',        // 工单列表
					7: '/asset_receive_apply/list',    	// 资产领用列表
					9: '/outsource/recruit/list',    	// 外协招工列表
					11: '/expense/reimbursement/list', 	// 报销单列表
					12: '/leave/application/list',     	// 请假单列表
					13: '/asset_return_apply/list',  	// 资产归还列表
					14: '/overtime/application/list',  	// 加班申请列表
					16: '/asset_repair_record/list',  	// 资产维修列表
				}[this.workType]
			}
		},

		mounted() {
			this.immediate && this.load();

			new Promise(resolve => {
				if (!this.customView) {
					this.request({
						url: '/sys_app_view/field_config',
						data: {
							view_id: this.viewId
						},
						success: data => {
							this.coverField = data.cover_field;
							this.titleField = data.title_field_list || [];
							this.countField = data.count_field;
							this.viewStore.commit('fieldList', data.field_list);
							resolve();
						}
					});
				} else {
					resolve();
				}
			}).then(() => {
				this._fieldComplete = true;
				this.loadData();
			})
			
			if (this.$scopedSlots.batch || this.approveType) {
				this._obBatchButton = () => {
					this.batchButton = this.$refs.batchButton.querySelectorAll('.c-button').length > 0;
				}
				new MutationObserver(mutations => {
					mutations.forEach(this._obBatchButton);
				}).observe(this.$refs.batchButton, {
					childList: true
				});
				this._obBatchButton();
			}
			
			this.$onShow(() => {
				this.update();
			});
		},

		activated() {
			if (this._deactivated) {
				delete this._deactivated;
				this.$refs.list.update();
			}
		},

		deactivated() {
			this._deactivated = true;
		},

		methods: {
			load(param) {
				this._parentComplete = true;
				this._parentParam = param;
				this.loadData();
			},

			update() {
				this.resetBatch(true);
				this.$refs.list.update();
				this.$refs.topbar && this.$refs.topbar.updateTabTotal(this.dataUrl);
			},

			topbarHandle() {
				this._topbarComplete = true;
				this.loadData();
			},

			loadData() {
				if (!this.dataUrl) return;
				if (!this._parentComplete || (this.topbar && !this._topbarComplete) || !this._fieldComplete) return;
				this.total = '-';
				this.resetBatch(true);
				this.lastLoadParams = Object.assign({}, this.topbar ? this.$refs.topbar.params : {view_id: this.viewId}, this._parentParam);
				this.$refs.list && this.$refs.list.load({
					url: this.dataUrl,
					data: this.lastLoadParams,
					dataFormatter: data => {
						return !this.customView ? data.map(data => {
							data.baseInfo = {
								cover: (() => {
									let value = this.coverField ? this.coverField.is_custom == 1 ? data.customFieldValues[this.coverField.field_code].value : data[this.coverField.field_code] : null;
									if (value && typeof value == 'string') {
										value = value.split(',');
									}
									return value ? value[0] : null;
								})(),
								title: this.titleField.map(item => {
									return item.is_custom == 1 ? data.customFieldValues[item.field_code].value : data[item.field_code];
								}).filter(item => item !== undefined && item !== null && item !== '').join(' | ').replace(/( \| )+/g, ' | ').replace(/\s\|\s$/, ''),
								count: this.countField ? {
									name: this.countField.field_title,
									value: this.countField.is_custom == 1 ? data.customFieldValues[this.countField.field_code].value : data[this.countField.field_code]
								} : null
							}
							return data;
						}) : data;
					},
					response: res => {
						this.total = res.total;
					}
				});
				this.topbar && this.$refs.topbar && this.$refs.topbar.updateTabTotal(this.dataUrl);
			},

			allCheckHandle(state) {
				if (state) {
					this.$refs.list.$children.forEach(item => {
						if (item.$options.name == 'viewListCard' && !item.checkState) {
							this.checkList.push(item.data.id);
						}
					});
				} else {
					this.viewStore.commit('checkList', []);
				}
				this.viewStore.commit('allCheckState', state);
			},

			resetBatch(cancel) {
				cancel && this.viewStore.commit('batchState', false);
				this.viewStore.commit('checkList', []);
				this.viewStore.commit('allCheckState', false);
			},

			batchHandle() {
				if (this.batchMenu) {
					this.batchMenu = false;
				} else {
					if (!this.checkList.length) {
						this.$message({
							message: '请选择要批量操作的数据'
						});
						return;
					}
					this.batchMenu = true;

					this._hideBatchMenu = () => {
						this.batchMenu = false;
						window.removeEventListener('click', this._hideBatchMenu);
					}
					window.addEventListener('click', this._hideBatchMenu);
				}
			},

			approveHandle(state) {
				let list = this.checkList;
				new Promise(async resolve => {
					if (state == 1 && await this.$confirm({
						message: `确定要批量通过选中的${list.length}条单据吗？`
					}) == 'resolve') {
						resolve();
					} else if (state == 9) {
						this.globalDialog('remark', {
							props: {
								title: '批量驳回',
								label: '驳回原因',
								placeholder: '驳回原因写这里...'
							}
						}, (stop, next, remark) => {
							if (!remark) {
								this.$message({
									message: '请填写驳回原因'
								});
								stop();
								return;
							}
							resolve({
								remark
							});
						});
					}
				}).then(data => {
					this.request({
						url: '/workflow/order/batch/approve',
						data: Object.assign({
							order_type: this.approveType,
							execute_state: state,
							order_ids: list
						}, data),
						loading: true,
						success: (data, message) => {
							this.$message({
								message
							});
							setTimeout(() => {
								this.update();
							}, 3000);
						}
					});
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-list-view {
		.batch {
			&-handle {
				height: .65rem;
				padding: 0 .32rem;
				font-size: .28rem;

				+ .c-scroll-list {
					>>> .card:nth-child(1) {
						margin-top: 0;
					}
				}
			}

			&-foot {
				z-index: 91;
				position: fixed;
				left: 0;
				right: 0;
				bottom: 0;
				height: 1.08rem;
				padding: .2rem .28rem var(--tabbar-bottom);
				background: #fff;
				box-shadow: none;
				transform: translate(0,100%);
				transition: transform .3s ease;

				&.z-active {
					box-shadow: 0 .04rem .15rem 0 rgba(0,0,0,.2);
					transform: translate(0,0);
				}

				p {
					position: .28rem;
					margin-left: .12rem;
					color: #666;

					span {
						color: var(--color-main);
					}
				}
			}

			&-button {
				position: relative;

				&-list {
					position: absolute;
					right: 0;
					bottom: 100%;
					width: 2.8rem;
					border-radius: .12rem;
					padding: .2rem 0;
					margin-bottom: .14rem;
					background: #444;
					box-shadow: 0 .02rem .15rem 0 rgba(0,0,0,.2);

					&:after {
						content: '';
						position: absolute;
						right: .2rem;
						bottom: -.1rem;
						border-top: .12rem solid #444;
						border-left: .12rem solid rgba(0,0,0,0);
						border-right: .12rem solid rgba(0,0,0,0);
					}

					>>> .c-button {
						display: flex;
						box-sizing: border-box;
						width: 100%;
						height: .8rem !important;
						border-radius: 0 !important;
						border: none;
						padding: 0 .26rem !important;
						text-align: left;
						font-size: .3rem !important;
						color: #fff;
						background: none;

						&:nth-child(even) {
							background: rgba(255,255,255,.08);
						}

						.icon {
							margin-right: .2rem;
							color: rgba(255,255,255,.7);
						}
					}
				}
			}
		}
		
		>>> .card {
			margin-top: .24rem;
		}
	}
</style>
